const inputStyle = { width: '100%', boxSizing: 'border-box', marginTop: 4 };

export function buildWorkerAttributeEventsColumns() {
  return [
    {
      key: 'timestamp', header: 'Timestamp', width: '30%', accessor: r => r.formattedTimestamp
    },
    {
      key: 'workerName', header: 'Worker Name', width: '30%', filterKey: 'workerName', accessor: r => r.workerName,
      filterRender: ({ value, onChange }) => <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
    },
    {
      key: 'description', header: 'Description', width: '40%', filterKey: 'description', render: r => r.descriptionNode,
      filterRender: ({ value, onChange }) => <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
    }
  ];
}
